import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {Observable, throwError, tap} from "rxjs";
import {LoginService} from "../services/login.service";
import {MessageCustomService} from "../services/message.custom.service";
import {SsrCookieService} from "ngx-cookie-service-ssr";

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

  constructor(private loginService: LoginService,
              private messageCustomService: MessageCustomService,
              private cookieService: SsrCookieService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if(!req.url.startsWith('https://www.commandetonbarman.fr/ctb')) {
      if (this.cookieService.get("auth-token")) {
        req = req.clone({
          setHeaders: {
            Authorization: 'Bearer ' + this.cookieService.get("auth-token")
          }
        });
      }
    }
    const start = Date.now();

    return next.handle(req).pipe(
      tap({
        next: event => {
        },
        error: error => {
          if (error instanceof HttpErrorResponse) {
            switch ((error as HttpErrorResponse).status) {
              case 401:
                return this.logoutUser();
              default:
                if(error.status == 0) {
                  this.messageCustomService.error("Le serveur n'est pas accessible, veuillez réessayer plus tard.");
                } if(error.error == "Erreur serveur") {
                this.messageCustomService.error("Une erreur s'est produite, l'équipe de Commande Ton Barman peut vous aider au 06 83 60 06 27")
              } else {
                this.messageCustomService.error(error.error);
              }
                return throwError(() => new Error(error.error));
            }
          } else {
            return throwError(() => new Error(error.error));
          }
        }
      })
    );
  }

  logoutUser() {
    this.loginService.logout();
    return throwError(() => new Error(""));
  }
}
